import { TrainingContent, TrainingQuiz, TrainingPage, TrainingQuizQuestion, TrainingQuizAnswer, AppliedTraining, TrainingProgress } from './../../model/TrainingModel';
import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, AlertController, ToastController, LoadingController, Slides, MenuController, Content } from 'ionic-angular';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/AppStore';
import { TrainingListContentAction, TrainingSaveQuizAction, TrainingSaveProgressAction, TrainingGetProgressAction, TrainingStatusUpdateAction, TrainingClearErrorsAction } from '../../store/action/TrainingActions';
import { TrainingService } from '../../services/TrainingSevice';

import * as Sentry from "@sentry/browser";
import { LogoutAction } from '../../store/action/UserActions';
import { SurveyClearErrorsAction } from '../../store/action/SurveyActions';
import { BrainstormClearErrorsAction } from '../../store/action/BrainstormActions';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { CronosClearErrorsAction } from '../../store/action/CronosActions';
import { LoginPage } from '../login/login';

@IonicPage()
@Component({
  selector: 'page-training-details',
  templateUrl: 'training-details.html',
})
export class TrainingDetailsPage {

  @ViewChild(Slides) slides: Slides;
  @ViewChild('contentMenu') content: Content;

  public isLoading: boolean;
  public selectedItem: AppliedTraining;
  public selectedType: number;
  public loader: Loading;
  public currentPage: number;
  public totalPages: number;
  public paginationVisible: boolean;
  public paginationPreviousVisible: boolean;
  public paginationNextVisible: boolean;
  public trainingContent: Array<TrainingContent>;
  private quizIdList: Array<number>;
  private trainingProgress: Array<TrainingProgress>;
  public quizList: Array<TrainingQuiz>;
  public menuList: Array<{ title: string, pageId: number, locked: boolean }>;
  public isPortrait: boolean;

  private userSubscription: Subscription;
  private trainingSubscription: Subscription;

  public midiaImagem: number = 1;
  public midiaVideo: number = 3;
  public midiaQuiz: number = 5;

  private clientId: number;

  private loggingOff: boolean;
  private firstTime: boolean;
  private contentLoaded: boolean;
  private loadingProgress: boolean;
  private accordLoaded: boolean;
  private accordAdesaoLoaded: boolean;
  private progressLoaded: boolean;
  public quizLoaded: boolean;
  private savingQuiz: boolean = false;
  private moveNext: boolean = false;
  private savingProgress: boolean = false;
  private menuOpened: boolean = false;
  private timeoutRotation: any;
  private acceptAccordAdesao: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    private store: Store<AppStore>,
    private cd: ChangeDetectorRef,
    private menuCtrl: MenuController,
    private trainingService: TrainingService
  ) {
    this.loggingOff = false;
    this.isLoading = false;
    this.loadingProgress = false;
    this.selectedItem = this.navParams.get('item');
    this.selectedType = this.navParams.get('type');
    this.firstTime = this.navParams.get('firstTime');
  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (10)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewDidLoad() {
    this.checkOrientation();
    this.menuCtrl.enable(true, 'menu2');
    this.menuCtrl.enable(false, 'menuPrincipal');
    this.contentLoaded = false;
    this.accordLoaded = false;
    this.accordAdesaoLoaded = false;
    this.quizLoaded = false;
    this.acceptAccordAdesao = false;
    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.clientId = userState.user.clienteId;
        Sentry.configureScope(scope => {
          scope.setUser({ id: userState.user.id.toString(), username: userState.user.nome });
        });
        Sentry.addBreadcrumb({ message: 'TrainingDetails -> Dispatch -> TrainingListContentAction' });
        this.store.dispatch(new TrainingListContentAction({
          trainingId: this.selectedItem.cursoId
        }));
      }
    });
    this.trainingSubscription = this.store.select('trainingState').subscribe(trainingState => {

      if ((trainingState.loadingTrainingContent || trainingState.loadingQuiz || trainingState.loadingSaveQuiz || trainingState.loadingSaveProgress || trainingState.loadingGetProgress) && !this.isLoading) {
        Sentry.captureEvent({ message: 'TrainingDetails -> trainingState.loading', extra: { 'state': JSON.stringify(trainingState) } });
        if (this.loader == null) {
          this.loader = this.loadingCtrl.create({
            content: 'Aguarde...'
          });
          this.loader.present();
        }
        this.isLoading = true;
      }
      if (!trainingState.loadingTrainingContent && !trainingState.loadingQuiz && !trainingState.loadingSaveQuiz && !trainingState.loadingSaveProgress && !trainingState.loadingGetProgress && this.isLoading) {
        Sentry.captureEvent({ message: 'TrainingDetails -> trainingState.loadingComplete', extra: { 'state': JSON.stringify(trainingState) } });
        this.loader.dismiss();
        this.loader = null;
        this.isLoading = false;
      }
      if (trainingState.errorTrainingContent || trainingState.errorQuiz || trainingState.errorGetProgress) {
        Sentry.captureEvent({ message: 'TrainingDetails -> trainingState.error1', extra: { 'state': JSON.stringify(trainingState) } });
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao carregar os dados do curso');
          }
        }, 1000);
      }
      if (trainingState.errorSaveQuiz) {
        Sentry.captureEvent({ message: 'TrainingDetails -> trainingState.error2', extra: { 'state': JSON.stringify(trainingState) } });
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao gravar a resposta do quiz');
          }
        }, 1000);
        return;
      }
      if (trainingState.errorSaveProgress) {
        Sentry.captureEvent({ message: 'TrainingDetails -> trainingState.error3', extra: { 'state': JSON.stringify(trainingState) } });
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao gravar o progresso do curso');
          }
        }, 1000);
        return;
      }
      if (!trainingState.loadingTrainingContent && trainingState.trainingContent != null && !this.contentLoaded) {
        Sentry.captureEvent({ message: 'TrainingDetails -> trainingState.contentLoaded', extra: { 'state': JSON.stringify(trainingState) } });
        this.contentLoaded = true;
        this.trainingContent = this.sortData(trainingState.trainingContent);
        if (this.selectedItem.termoAceite == true) {
          if (!this.accordLoaded) {
            this.trainingService.getAccordTraining(this.selectedItem.clienteId, this.selectedItem.termoAceiteId)
              .subscribe(res => {
                this.selectedItem.termoInfo = res;
                this.accordLoaded = true;
              }, err => {
                this.presentToast('erro ao carregar o termo de aceite do treinamento');
              });
          }
        } else {
          this.accordLoaded = true;
        }
        if (this.selectedItem.termoAdesao == true) {
          if (!this.accordAdesaoLoaded) {
            this.trainingService.getAccordTraining(this.selectedItem.clienteId, this.selectedItem.termoAdesaoId)
              .subscribe(res => {
                this.selectedItem.termoAdesaoInfo = res;
                this.accordAdesaoLoaded = true;
              }, err => {
                this.presentToast('erro ao carregar o termo de adesão do treinamento');
              });
          }
        } else {
          this.accordAdesaoLoaded = true;
        }
        this.fillQuiz();
        this.updateNavigation();
        if (this.firstTime) {
          this.savePageChange();
          this.progressLoaded = true;
          this.loadingProgress = false;
          this.updateNavigation();
          this.slideToPageProgress();
        } else {
          this.progressLoaded = false;
          this.loadingProgress = true;
          Sentry.addBreadcrumb({ message: 'TrainingDetails -> Dispatch -> TrainingGetProgressAction' });
          this.store.dispatch(new TrainingGetProgressAction({
            clienteId: this.clientId,
            alunoId: this.selectedItem.alunoId,
            cursoId: this.selectedItem.cursoId
          }));
        }
      }
      if (!trainingState.loadingGetProgress && trainingState.progress != null && this.contentLoaded == true && !this.savingProgress && !this.progressLoaded && !this.loadingProgress) {
        Sentry.captureEvent({ message: 'TrainingDetails -> trainingState.progress', extra: { 'state': JSON.stringify(trainingState) } });
        if (trainingState.progress && trainingState.progress.length > 0) {
          this.trainingProgress = trainingState.progress;
          this.updateNavigation();
          if (this.selectedItem.status != 3)
            this.slideToPageProgress();
        }
      }
      this.loadingProgress = false;
      if (!trainingState.loadingSaveQuiz && this.savingQuiz) {
        this.slides.lockSwipeToNext(false);
        if (this.moveNext) {
          this.moveNext = false;
          this.slideNext();
        }
        this.savingQuiz = false;
      }
      if (!trainingState.loadingSaveProgress && this.savingProgress) {
        this.savingProgress = false;
      }
    });
  }

  openMenu() {
    if (!this.menuOpened) {
      this.menuCtrl.open();
      this.menuOpened = true;
    } else {
      this.menuCtrl.close();
      this.menuOpened = false;
    }
  }

  ionViewWillLeave() {
    this.menuCtrl.enable(false, 'menu2');
    this.menuCtrl.enable(true, 'menuPrincipal');
    if (this.userSubscription != null) { this.userSubscription.unsubscribe() };
    if (this.trainingSubscription != null) { this.trainingSubscription.unsubscribe() };
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  sortData(content: Array<TrainingContent>): Array<TrainingContent> {
    const sortFn = (n1: any, n2: any): number => {
      if (n1.sequencia == null || n2.sequencia == null) {
        return n1.id - n2.id;
      } else {
        return n1.sequencia - n2.sequencia;
      }
    };

    let contentReturn = new Array<TrainingContent>(...content);
    this.quizIdList = new Array<number>();

    this.totalPages = 0;
    if (contentReturn != null) {
      contentReturn = contentReturn.sort(sortFn);
      contentReturn.forEach(conteudo => {
        if (conteudo.aulas != null) {
          conteudo.aulas = conteudo.aulas.sort(sortFn);
          conteudo.aulas.forEach(aula => {
            if (aula.topicos != null) {
              aula.topicos.sort(sortFn);
              aula.topicos.forEach(topico => {
                if (topico.paginas != null) {
                  topico.paginas = topico.paginas.sort(sortFn);
                  topico.paginas.forEach(pagina => {
                    if (pagina.typemidia == this.midiaQuiz && this.selectedItem.status != 3) {
                      this.quizIdList.push(pagina.midiaId);
                    }
                    this.totalPages = this.totalPages + 1;
                  });
                };
              });
            }
          });
        }
      });
    }

    let clientId = this.clientId;
    if (this.selectedType == 1) {
      clientId = 1;
    }

    if (this.quizIdList != null && this.selectedItem.status != 3) {
      this.trainingService.listTrainingQuiz(clientId, this.quizIdList)
        .subscribe(resp => {
          this.quizList = resp;
          this.quizLoaded = true;
          this.setStartupState();
        },
          err => {
            this.presentToast('Erro ao carregar os dados da quiz');
            this.quizLoaded = true;
            this.setStartupState();
          });
    } else {
      this.quizLoaded = true;
      this.setStartupState();
    }

    return contentReturn;
  }

  setStartupState() {
    this.currentPage = 1;
    this.paginationVisible = true;
    this.paginationNextVisible = true;
    this.paginationPreviousVisible = false;
  }

  fillQuiz() {

    if (!this.quizLoaded) {
      setTimeout(() => {
        this.fillQuiz();
      }, 100);
      return;
    }

    const sortFn = (n1: any, n2: any): number => {
      if (n1.sequencia == null || n2.sequencia == null) {
        return n1.id - n2.id;
      } else {
        return n1.sequencia - n2.sequencia;
      }
    };

    this.trainingContent.forEach(conteudo => {
      conteudo.aulas.forEach(aula => {
        aula.topicos.forEach(topico => {
          topico.paginas.forEach(pagina => {
            if (pagina.typemidia == this.midiaQuiz && pagina.quiz == null && this.selectedItem.status != 3) {
              this.quizList.forEach(ql => {
                if (ql.id == pagina.midiaId) {
                  pagina.quiz = ql;
                  pagina.quiz.sucesso = false;
                  pagina.quiz.score = 0;
                }
              });
              if (pagina.quiz != null) {
                this.totalPages = this.totalPages + 1;
                pagina.quiz.perguntas = pagina.quiz.perguntas.sort(sortFn);
                pagina.quiz.perguntas.forEach(pergunta => {
                  pergunta.respostas = pergunta.respostas.sort(sortFn);
                  this.totalPages = this.totalPages + 1;

                  this.trainingService.getAnswerQuiz(this.clientId, this.selectedItem.alunoId, this.selectedItem.cursoId, pagina.quiz.id, pagina.id)
                    .subscribe(resp => {
                      if (resp != null && resp.length > 0) {
                        if (resp[0].resposta != null) {
                          if (pergunta.typeresposta == 1) {
                            pergunta.respostaSelecionada = resp[0].resposta;
                          } else if (pergunta.typeresposta == 2) {
                            pergunta.respostasSelecionadas = resp[0].resposta.split(',');
                          } else {
                            pergunta.respostasSelecionadas = new Array();
                            resp[0].resposta.split(',').forEach(x => {
                              if (x.indexOf('-V') >= 0) {
                                pergunta.respostasSelecionadas.push(x);
                              }
                            });
                          }
                        }
                      }
                    }, err => {
                      this.presentToast('erro ao obter respostas do quiz');
                    });
                });
              }
            }
          })
        })
      })
    });
  }

  controlChange() {
    const type = this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-slideType');
    this.changeSlideStatus(type);
  }

  updateNavigation() {

    this.menuList = new Array<{ title: string, pageId: number, locked: boolean }>();
    this.trainingContent.forEach(conteudo => {
      let hasMenuContent = false;
      conteudo.aulas.forEach(aula => {
        let hasMenuAula = false;
        aula.topicos.forEach(topico => {
          let hasMenuTopico = false;
          topico.paginas.forEach(pagina => {
            if (!hasMenuContent) {
              hasMenuContent = true;
              this.menuList.push({ title: conteudo.descricao, pageId: null, locked: false });
            }
            if (aula.visivel && !hasMenuAula) {
              hasMenuAula = true;
              this.menuList.push({ title: aula.descricao, pageId: null, locked: false });
            }
            if (!hasMenuTopico) {
              hasMenuTopico = true;
              let locked = true;
              if (this.trainingProgress == null) {
                locked = !topico.unlock;
              } else {
                if (this.trainingProgress.find(x => x.paginaId == pagina.id)) {
                  locked = false;
                } else {
                  locked = true;
                }
              }

              this.menuList.push({ title: topico.descricao, pageId: pagina.id, locked: locked });
            }
          })
        })
      })
    });
  }

  videoFinished(paginaId: number) {
    const video: any = document.getElementById('video' + paginaId);
    const playText = document.getElementById('play-pause-text' + paginaId);
    const playIcon = document.getElementById('play-pause-icon' + paginaId);
    video.pause();
    playIcon.className = playIcon.className.replace('pause', 'play');
    playText.innerHTML = 'Tocar';
    this.slides.lockSwipeToNext(false);
  }

  changeSlideStatus(type: string) {
    switch (type) {
      case '3':
        this.savePageChange(true);
        const videoPageId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-page'), 10);

        const video: any = document.getElementById('video' + videoPageId);
        const playButton = document.getElementById('play-pause' + videoPageId);
        const playText = document.getElementById('play-pause-text' + videoPageId);
        const playIcon = document.getElementById('play-pause-icon' + videoPageId);
        const beginButton = document.getElementById('beginVideo' + videoPageId);
        const fullScreenButton = document.getElementById('full-screen' + videoPageId);

        playButton.addEventListener('click', function () {
          if (video.paused == true) {
            video.play();
            playIcon.className = playIcon.className.replace('play', 'pause');
            playText.innerHTML = 'Pausar';
          } else {
            video.pause();
            playIcon.className = playIcon.className.replace('pause', 'play');
            playText.innerHTML = 'Tocar';
          }
        });

        beginButton.addEventListener('click', function () {
          video.currentTime = 0;
        });

        fullScreenButton.addEventListener('click', function () {
          if (video.requestFullscreen) {
            video.requestFullscreen();
          } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
          }
          if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          }
          if (video.enterFullscreen) {
            video.enterFullscreen();
          }
        });

        break;

      case '5':

        const questionId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-question'), 10);
        const pageQuizId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-page'), 10);
        const topicQuizId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-topic'), 10);
        const classQuizId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-class'), 10);
        const contentQuizId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-content'), 10);

        let currentQuizPage: TrainingPage = this.trainingContent
          .find(x => x.id == contentQuizId).aulas
          .find(x => x.id == classQuizId).topicos
          .find(x => x.id == topicQuizId).paginas
          .find(x => x.id == pageQuizId);

        let currentQuestion = currentQuizPage.quiz.perguntas.find(x => x.id == questionId);
        let lockNext: boolean = false;
        if (currentQuestion.typeresposta == 1) {
          lockNext = currentQuestion.respostaSelecionada == null;
        } else if (currentQuestion.typeresposta == 2) {
          lockNext = currentQuestion.respostasSelecionadas == null || currentQuestion.respostasSelecionadas.length == 0;
        }

        this.savingQuiz = false;
        this.savePageChange(lockNext);
        break;
      case '98':
        this.slides.lockSwipeToNext(true);
        break;
      case '99':
        const pageId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-page'), 10);
        const topicId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-topic'), 10);
        const classId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-class'), 10);
        const contentId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-content'), 10);

        let currentPage: TrainingPage = this.trainingContent
          .find(x => x.id == contentId).aulas
          .find(x => x.id == classId).topicos
          .find(x => x.id == topicId).paginas
          .find(x => x.id == pageId);

        this.slides.lockSwipeToNext(!currentPage.quiz.sucesso);

        this.savingProgress = false;

        break;
      case '100':

        this.selectedItem.status = 3;
        this.selectedItem.dataConclusao = new Date();
        let qtdeQuiz = 0;
        let scoreTotal = 0;
        this.trainingContent.forEach(content => {
          content.aulas.forEach(aula => {
            aula.topicos.forEach(topico => {
              topico.paginas.forEach(pagina => {
                if (pagina.quiz != null) {
                  scoreTotal += pagina.quiz.score;
                  qtdeQuiz++;
                }
              });
            });
          });
        });
        if (qtdeQuiz > 0) {
          this.selectedItem.score = Number((scoreTotal / qtdeQuiz).toFixed(2));
        } else {
          this.selectedItem.score = null;
        }
        this.selectedItem.totalPaginaRealizadaCurso = this.selectedItem.totalPaginaCurso;
        if (this.acceptAccordAdesao) {
          this.selectedItem.adesaoTermo = 'SIM';
          this.selectedItem.dataAdesaoTermo = new Date();
        }
        Sentry.addBreadcrumb({ message: 'TrainingDetails -> Dispatch -> TrainingStatusUpdateAction' });
        this.store.dispatch(new TrainingStatusUpdateAction({ data: this.selectedItem }));

        this.slides.lockSwipeToNext(true);
        this.slides.lockSwipeToPrev(true);

        this.paginationVisible = false;

        break;

      case '0':

        this.slides.lockSwipeToNext(true);
        this.paginationVisible = false;

        break;

      default:
        this.savePageChange();
        break;
    }
    this.cd.markForCheck();
  }

  acceptAccord() {
    this.selectedItem.aceiteTermo = 'SIM';
    this.selectedItem.dataAceiteTermo = new Date();
    this.store.dispatch(new TrainingStatusUpdateAction({ data: this.selectedItem }));

    this.slides.lockSwipeToNext(false);
    this.paginationVisible = true;

    this.slideNext();
  }

  cancelAccord() {
    this.presentToast('Termo de aceite recusado');
    this.navCtrl.pop();
  }

  acceptAccordAdesaoOk() {
    this.slides.lockSwipeToNext(false);
    this.acceptAccordAdesao = true;
    this.slideNext();
  }

  cancelAccordAdesao() {
    this.presentToast('Termo de adesão recusado');
    this.navCtrl.pop();
  }

  savePageChange(lock: boolean = false) {
    if (!this.contentLoaded || !this.quizLoaded || this.slides == null || this.slides._slides == null) {
      setTimeout(() => {
        this.savePageChange();
      }, 200);
      return;
    }

    this.savingProgress = true;
    const pageId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-page'), 10);
    const topicId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-topic'), 10);
    const classId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-class'), 10);
    const contentId: number = parseInt(this.slides._slides[this.slides.getActiveIndex()].getAttribute('data-content'), 10);

    const progress = {
      clienteId: this.clientId,
      alunoId: this.selectedItem.alunoId,
      cursoId: this.selectedItem.cursoId,
      conteudoId: contentId,
      aulaId: classId,
      topicoId: topicId,
      paginaId: pageId,
      positionMidia: 0
    };
    if (this.trainingProgress == null) {
      this.trainingProgress = new Array<TrainingProgress>();
    }
    this.trainingProgress.push(progress);

    Sentry.addBreadcrumb({ message: 'TrainingDetails -> Dispatch -> TrainingSaveProgressAction' });
    this.store.dispatch(new TrainingSaveProgressAction({
      data: progress
    }));

    this.updateNavigation();

    this.slides.lockSwipeToNext(lock);
  }

  slideNext() {
    this.slides.slideNext();
    this.cd.markForCheck();
  }

  slidePrevious() {
    this.slides.slidePrev();
    this.cd.markForCheck();
  }

  calculatePaginationNext() {
    if (this.currentPage < this.totalPages) {
      this.currentPage = this.currentPage + 1;
    }
    this.showHideNextPrevious();
  }

  calculatePaginationPrev() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
    }
    this.showHideNextPrevious();
  }

  showHideNextPrevious() {
    if (this.quizLoaded) {
      this.paginationNextVisible = this.slides.getActiveIndex() < this.slides.length() - 1;
      this.paginationPreviousVisible = this.slides.getActiveIndex() > 0;
    }
  }

  answerQuestionRadio(question: TrainingQuizQuestion, pageId: number, quizId: number, topicoId: number, aulaId: number, conteudoId: number, e) {
    question.respostaSelecionada = e;
    this.savingQuiz = true;
    this.moveNext = true;
    Sentry.addBreadcrumb({ message: 'TrainingDetails -> Dispatch -> TrainingSaveQuizAction' });
    this.store.dispatch(new TrainingSaveQuizAction({
      data: {
        clienteId: this.clientId,
        alunoId: this.selectedItem.alunoId,
        cursoId: this.selectedItem.cursoId,
        conteudoId: conteudoId,
        aulaId: aulaId,
        topicoId: topicoId,
        paginaId: pageId,
        quizId: quizId,
        perguntaId: question.id,
        typeresposta: question.typeresposta,
        resposta: e,
        scorePergunta: question.score,
        timestamp: null
      }
    }));
  }

  answerQuestionMultiple(question: TrainingQuizQuestion, answer: TrainingQuizAnswer, pageId: number, quizId: number, topicoId: number, aulaId: number, conteudoId: number, e) {
    if (e.checked) {
      if (question.respostasSelecionadas == null) {
        question.respostasSelecionadas = new Array<string>();
      }
      question.respostasSelecionadas.push(answer.id.toString());
    } else {
      if (question.respostasSelecionadas != null) {
        const idx = question.respostasSelecionadas.findIndex(x => x == answer.id.toString());
        question.respostasSelecionadas.splice(idx, 1);
      }
    }
    let respSelect = '';
    if (question.respostasSelecionadas != null) {
      respSelect = question.respostasSelecionadas.join(',');
      if (question.typeresposta == 3) {
        respSelect = '';
        question.respostas.forEach(x => {
          if (question.respostasSelecionadas.find(y => y == x.id.toString())) {
            respSelect += ',' + x.id.toString() + '-V';
          } else {
            respSelect += ',' + x.id.toString() + '-F';
          }
        });
        respSelect = respSelect.substring(1);
      }
    }

    if (question.typeresposta == 2 && (question.respostasSelecionadas == null || question.respostasSelecionadas.length == 0)) {
      this.slides.lockSwipeToNext(true);
      return;
    }

    this.savingQuiz = true;
    this.moveNext = false;
    Sentry.addBreadcrumb({ message: 'TrainingDetails -> Dispatch -> TrainingSaveQuizAction' });
    this.store.dispatch(new TrainingSaveQuizAction({
      data: {
        clienteId: this.clientId,
        alunoId: this.selectedItem.alunoId,
        cursoId: this.selectedItem.cursoId,
        conteudoId: conteudoId,
        aulaId: aulaId,
        topicoId: topicoId,
        paginaId: pageId,
        quizId: quizId,
        perguntaId: question.id,
        typeresposta: question.typeresposta,
        resposta: respSelect,
        scorePergunta: question.score,
        timestamp: null
      }
    }));
  }

  restartQuiz(page: TrainingPage, clear: boolean) {
    if (clear) {
      page.quiz.perguntas.forEach(x => {
        x.respostaSelecionada = null;
        x.respostasSelecionadas = null;
      });
    }
    this.slideToPage(page.id);
  }

  slideToPage(pageId: number) {
    let found = false;
    let idx = 0;
    this.slides._slides.forEach((el, i) => {
      if (el.getAttribute('data-page') == pageId.toString()) {
        if (!found) {
          idx = i;
          found = true;
        }
      }
    });
    if (found) {
      this.slides.slideTo(idx);
      this.currentPage = idx + 1;
    }
    this.menuOpened = false;
  }

  slideToPageProgress() {
    if (!this.contentLoaded || !this.quizLoaded || this.slides == null || this.slides._slides == null) {
      setTimeout(() => {
        this.slideToPageProgress();
      }, 200);
      return;
    }
    let found = false;
    let idx = 0;
    this.slides._slides.forEach((el, i) => {
      const item = (this.trainingProgress) ? this.trainingProgress.find(x => x.paginaId.toString() == el.getAttribute('data-page')) : null;
      const type = el.getAttribute('data-slideType');
      if (item != null && !found && type != '99') {
        if (type == '5') {
          const quizIndex = el.getAttribute('data-quizIndex');
          if (quizIndex == '0') {
            idx = i;
          }
        } else {
          idx = i;
        }
      } else {
        if (type != '98' && type != '99') {
          found = true;
        }
      }
    });
    if (found) {
      this.slides.slideTo(idx);
      this.currentPage = idx + 1;
      if (idx == 0) {
        const type = this.slides._slides[0].getAttribute('data-slideType');
        this.changeSlideStatus(type);
      }
    }
    this.progressLoaded = true;
    this.menuOpened = false;
  }

  calculateQuiz(page: TrainingPage) {
    let scoreTotal: number = 0;

    page.quiz.perguntas.forEach(q => {

      if (q.typeresposta == 1) {
        if (q.respostacorreta == q.respostaSelecionada) {
          q.score = 100;
        } else {
          q.score = 0;
        }
      } else if (q.typeresposta == 2) {
        const respostasCorretas: Array<string> = q.respostacorreta.split(',').sort();
        let respostasSelecionadas = new Array<string>();
        if (q.respostasSelecionadas) {
          respostasSelecionadas = q.respostasSelecionadas.sort();
        }
        const correto = respostasSelecionadas.length == respostasCorretas.length && respostasCorretas.toString() == respostasSelecionadas.toString();
        if (correto) {
          q.score = 100;
        } else {
          q.score = 0;
        }
      } else if (q.typeresposta == 3) {
        const respostasCorretas2: Array<string> = q.respostacorreta.split(',').sort();
        let respostasSelecionadas2 = new Array<string>();
        if (q.respostasSelecionadas) {
          respostasSelecionadas2 = q.respostasSelecionadas.sort();
        }
        let corretoCount = 0;
        respostasCorretas2.forEach(x => {
          if (x.indexOf('-V') >= 0 && respostasSelecionadas2.find(y => y == x.replace('-V', ''))) {
            corretoCount++;
          }
          else if (x.indexOf('-F') >= 0 && !respostasSelecionadas2.find(y => y == x.replace('-F', ''))) {
            corretoCount++;
          }
        });
        q.score = (corretoCount / respostasCorretas2.length) * 100;
      }

      scoreTotal += q.score;

    });

    page.quiz.score = Number((scoreTotal / page.quiz.perguntas.length).toFixed(2));
    page.quiz.sucesso = page.quiz.score >= page.quiz.scoreMin;

    this.slides.lockSwipeToNext(false);
    this.slideNext();
  }

  inArray(arr: Array<string>, value: number): boolean {
    return arr != null && arr.find(x => x == value.toString()) != null;
  }

  ngAfterContentChecked(): void {
    if (this.timeoutRotation) {
      clearTimeout(this.timeoutRotation);
    }
    this.checkOrientation();
    this.timeoutRotation = setTimeout(() => {
      if (this.cd) {
        try {
          this.cd.detectChanges();
        } catch (e) {

        }
      }
    }, 500);
  }
  checkOrientation() {
    let currentOrientation: boolean;
    if (window.matchMedia("(orientation: portrait)").matches) {
      currentOrientation = true;
    } else {
      currentOrientation = false;
    }
    if (currentOrientation != this.isPortrait) {
      if (this.content) { this.content.resize(); }
    }
    this.isPortrait = currentOrientation;
  }
}



// WEBPACK FOOTER //
// ./src/pages/training-details/training-details.ts